/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";

import CRMMailTemplateHeader from "../CRMMailTemplateHeader/CRMMailTemplateHeader";
import MailTemplateFilterPopup from "components/Common/Popup/MailTemplateFilterPopup";
// import SaveMailTemplatePopup from "../Popup/SaveMailTemplatePopup";

/*import url and gateway methods */
import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";

import { crmCommonHeaderLinkLists } from "helper/CrmHelper/CrmHelper";
import { assetImages } from "constants";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import { replaceListByIds } from "helper/Common/CommonHelper";

const CRMMailTemplateBody = () => {
  const token = localStorage.getItem("token"); // token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();

  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: "CRM", link: "/admin/crm/mailtemplate/list" },
    { title: t("Mail Template") },
  ];

  // common header object
  const commonHeaderObject = crmCommonHeaderLinkLists(t);

  const [tagList, setTagList] = useState([]);
  const [templateList, setTemplateList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // const [templateId, setTemplateId] = useState(null);
  const [rowSelection, setRowSelection] = useState({});
  const [selectedTemplateIds, setSelectedTemplateIds] = useState([]);
  const [selectedTagId, setSelectedTagId] = useState(null);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);

  const [filterDates, setfilterDates] = useState("");
  const [filterName, setfilterName] = useState("");
  const [filterSlug, setfilterSlug] = useState("");
  const [filterSubject, setfilterSubject] = useState("");
  const [filterLabels, setfilterLabels] = useState([]);

  const [isReload, setIsReload] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);

  //* alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const getAllMailTemplates = async () => {
    setRowSelection({});
    setSelectedTemplateIds([]);
    setIsLoading(true);

    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_MAIL_TEMPLATES +
        `?token=${token}&modulename=crm`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl = requestUrl + `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      const response = await getData(requestUrl);

      console.log(response);

      setIsLoading(false);
      if (response.status) {
        setTemplateList(response.data);

        setMessageType("success");
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for change status
  const changeStatusHandler = async () => {
    if (selectedTemplateIds.length > 0) {
      let responseArr = [];

      for (let selectedId of selectedTemplateIds) {
        try {
          let templateData = {
            status: "0",
          };

          let requestUrl =
            url.API_BASE_URL +
            url.API_UPDATE_MAIL_TEMPLATE +
            `/${selectedId}` +
            `?token=${token}`;

          const response = await putData(requestUrl, templateData);

          if (response.status) {
            setMessageType("success");
            responseArr.push(true);
          } else {
            setMessageType("error");
          }

          setAlertMessage(response.message);
        } catch (error) {
          setMessageType("error");
          setAlertMessage(error.message);
        }
        setShowAlert(true);
      }

      if (responseArr.length > 0) {
        setTimeout(() => {
          getAllMailTemplates();
        }, 2000);
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select template for delete");
      setShowAlert(true);
    }
  };

  //function for reset filter
  const resetFilterData = () => {
    setIsFilterReset(true);
    setJsonFilterQuery([]);
    setIsReload(true);
  };

  useEffect(() => {
    if (isReload) {
      getAllMailTemplates();
      setIsReload(false);
    }
  }, [isReload]);

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllMailTemplates();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    getAllMailTemplates();
  }, []);

  /*
   * Material React Table Column and States
   */
  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        Cell: ({ row }) => (
          <Link
            to={`/admin/crm/mailtemplate/save/${row.original._id}`}
            className="action_btn_mui"
            aria-controls="addTask_view"
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </Link>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        accessorKey: "name",
        header: t("Template Name"),
      },
      {
        accessorKey: "tagstring",
        header: t("Label"),
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.tags && row.original.tags.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.tags &&
                    row.original.tags.map((tag, index) => (
                      <li key={index} className="d-inline-flex">
                        <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                          <span className="badge-text fs-xs fw-medium me-1">
                            {tag.title}
                          </span>
                          <Link
                            to="#"
                            className={`${
                              tag.moderator.toString() ===
                                userInfo._id.toString() ||
                              userInfo.role.slug === "ADMIN" ||
                              userInfo.role.slug === "SUPER_ADMIN"
                                ? "d-block"
                                : "d-none"
                            }`}
                            onClick={() => {
                              setSelectedTemplateId(row.original._id);
                              setSelectedTagId(tag._id);
                              removeTagFromTemplate(
                                [tag._id],
                                row.original._id
                              );
                            }}
                          >
                            {selectedTagId &&
                            selectedTagId === tag._id &&
                            selectedTemplateId &&
                            selectedTemplateId === row.original._id ? (
                              <div
                                className="spinner-border spinner-border-sm text-primary ms-1"
                                role="status"
                                style={{ height: "12px", width: "12px" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              <span
                                className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                                style={{ cursor: "pointer" }}
                              >
                                cancel
                              </span>
                            )}
                          </Link>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedTemplateIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        accessorKey: "slug",
        header: t("Slug"),
      },
      {
        accessorKey: "ownername",
        header: t("Owner"),
      },
      {
        accessorKey: "createdate",
        header: t("Date"),
      },
    ],
    [i18n.language, templateList, selectedTagId, selectedTemplateId]
  );

  //initialize the column order
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  useEffect(() => {
    //do something when the row selection changes...
    // console.info("rowSelection", rowSelection);
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );
    if (selectedIdsArray.length > 0) {
      setSelectedTemplateIds(selectedIdsArray);
    } else {
      setSelectedTemplateIds([]);
    }
  }, [rowSelection]);

  //* This is a function that is called when the alert close button is clicked.
  const onAlertClose = () => {
    // Set the state variable 'showAlert' to false to hide the alert.
    setShowAlert(false);

    // Clear the alert message by setting the state variable 'alertMessage' to an empty string.
    setAlertMessage("");

    // Clear the alert type by setting the state variable 'messageType' to an empty string.
    setMessageType("");
  };

  // function for remove tag from template
  const removeTagFromTemplate = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_TAG_TO_TEMPLATE;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      // console.log("response in remove tag from lead------->", data);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedTemplateId(null);
      }, 1000);
    }
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setTemplateList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CRM") &&
      moduleAccess.includes("MOD_MAIL_TEMPLATE"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Mail Templates")}
          />
          <div className="container-fluid px-lg-5">
            <CRMMailTemplateHeader
              breadcrumbText={breadcrumbText}
              reloadMailTemplate={resetFilterData}
              jsonFilterQuery={jsonFilterQuery}
              selectedTemplateIds={selectedTemplateIds}
            />
            {isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={templateList} // data from api to be displayed
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection, columnOrder: initialColumnOrder }} //pass our managed row selection state to the table to use
                  initialState={{
                    rowSelection,
                    columnOrder: initialColumnOrder,
                  }}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
          {/* ==== modals and popup section === */}
          {/* --- filter popup --- */}
          <MailTemplateFilterPopup
            jsonFilterQuery={jsonFilterQuery}
            setJsonFilterQuery={setJsonFilterQuery}
            moduleSlug={"crm_mail_template"}
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
            reloadList={resetFilterData}
          />
          {/* --- edit template popup --- */}
          {/* <SaveMailTemplatePopup
            afterPopupClose={getAllMailTemplates}
            templateId={templateId}
            setTemplateId={setTemplateId}
          /> */}

          <AddLabelModal
            moduleName="crmtemplate"
            selectedIds={selectedTemplateIds}
            afterTagModalClose={afterModalActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            selectedTagId={selectedTagId}
            setSelectedTagId={setSelectedTagId}
            removeTagFromLead={() => {}}
            userInfo={userInfo}
          />

          {/* ----------- delete warning modal ------------ */}
          <DeleteWarningModal
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedTemplateIds([]);
            }}
            onDelete={changeStatusHandler}
            moduleName={t("mail template")}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};
export default CRMMailTemplateBody;
